import {apiGet, apiPost} from "../../shared/api/client";
import {buildPolicyPayload} from "./contracts";
import {i18n} from "../../shared/i18n";


const REFERRAL_V2_PATH = "/api/v2/admin/referral-v2";

const requiredTenantId = (value) => {
    const normalized = String(value ?? "").trim();
    if (!/^[1-9]\d*$/.test(normalized)) throw new Error(i18n.t("sections.referralPolicies.p54"));
    return normalized;
};

const requiredVersionId = (value) => {
    const normalized = String(value ?? "").trim();
    if (!normalized) throw new Error(i18n.t("sections.referralPolicies.p55"));
    return normalized;
};

export const referralPolicyKeys = {
    all: (tenantId) => ["admin-referral-policies", String(tenantId ?? "")],
    list: (tenantId) => ["admin-referral-policies", String(tenantId ?? ""), "list"],
};

export const listReferralPolicies = ({tenantId}) =>
    apiGet(`${REFERRAL_V2_PATH}/policies`, {params: {tenant_id: requiredTenantId(tenantId)}});

export const createReferralPolicyVersion = (draft) =>
    apiPost(`${REFERRAL_V2_PATH}/policies`, buildPolicyPayload(draft));

// Активировать можно только draft — активная версия иммутабельна.
export const activateReferralPolicyVersion = ({versionId}) =>
    apiPost(`${REFERRAL_V2_PATH}/policy-versions/${requiredVersionId(versionId)}/activate`, {});
